module.exports = "/build/web/svg/App-Store-Badge.2bb3483b53cf1f838060d9428e2d336d.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/App-Store-Badge.svg
// module id = 142
// module chunks = 24